import React from "react";
import ReactImageMagnify from "react-image-magnify";

const MyReactImageMagnify = ({ image }) => {
  return (
    <div style={{ width: "100%" }}>
      <ReactImageMagnify
        {...{
          smallImage: {
            alt: "Product",
            isFluidWidth: true,
            src: image,
          },
          largeImage: {
            src: image,
            width: 1000,
            height: 1000,
          },
          enlargedImagePosition: "over", // side preview
          enlargedImageContainerDimensions: {
            width: "100%",
            height: "100%",
          },
          lensStyle: {
            backgroundColor: "rgba(0,0,0,.3)",
          },
        }}
      />
    </div>
  );
};

export default MyReactImageMagnify;